
import { useContext } from "react";
import { Link } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import { textes } from "../../constants/textes";


export default function SousAbonnement({sous, position}) {
    // states
    const {user} = useContext(UserContext);


    // comportements


    // Affichage
    return (
        <tr style={{borderStyle: "none"}}>
            <td className="text-center">{position + 1}</td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={sous.photo !== null ? sous?.photo : "/assets/imgs/blank.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{sous?.nomtransaction}</div>
                        <div className="widget-subheading">{sous?.email}</div>
                    </div>
                </div>
            </td>
            <td>
                <div className="d-flex flex-row">
                    <div className="widget-content-left mr-3">
                        <img style={{width: 48, height: 48}} className="rounded" src={sous.imgabonnement !== null ? sous?.imgabonnement : "/assets/imgs/no-image.png"} alt="" />
                    </div>
                    <div className="widget-content-left">
                        <div className="widget-heading">{sous?.libabonnement}</div>
                        <div className="widget-subheading">{sous?.prof}</div>
                    </div>
                </div>
            </td>
            <td>{sous.duree !== null ? sous?.duree : ""}</td>
            <td>{sous?.datedeb !== null ? sous?.datedeb.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>{sous?.datefin !== null ? sous?.datefin.slice(0, 16).replace("T", " à ") : ""}</td>
            <td>
                <span 
                    className={`badge ${
                        sous.etat === 1 ? "badge-success" : 
                        sous.etat === 2 ? "badge-warning" : 
                        (sous.etat === 3 || sous.etat === 10) ? "badge-danger" : 
                        ""
                        } mt-2`
                    } 
                    style={{fontSize: 14}}>
                        {
                            sous.etatdef !== null ? sous?.etatdef : 
                            "Etat"
                        }
                </span>
            </td>
            <td>{sous?.datecrea.slice(0, 16).replace("T", " à ")}</td>
            <td className="text-center">
                {(user?.isFullAction || user?.isAdminAction || user?.isConsulterSouscription) && 
                    <Link to={`/sous-abonnement/${sous?.code}`} data-toggle="tooltip" title={textes.fr.viewsouscriptionlabel} data-placement="left" className="btn-shadow-primary mr-2 ml-2 btn btn-sm btn-primary">
                        <i className="fa fa-eye"></i>
                    </Link>
                }
            </td>
        </tr>
    )
}